<div class="max-w-6xl mx-auto p-6 grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
  <!-- Image -->
  <div class="w-full">
    <img [src]="environment.apiBaseUrl+product.imagePath"
         [alt]="product.name"
         class="w-full rounded-2xl shadow-md" />
  </div>

  <!-- Details -->
  <div class="space-y-6">
    <h1 class="text-3xl font-bold text-left">{{ product.name }}</h1>
    <!--<p class="text-gray-600 text-lg">Brand: <strong>{{ product.brand }}</strong></p>-->
    <!-- Rating -->
    <!--<div class="flex items-center gap-1">
    <span class="text-yellow-400 text-lg">★</span>
    <span class="text-gray-700 text-sm">{{ product.rating }}/5</span>
  </div>-->
    <!-- Price -->
    <div class="flex items-center gap-4 text-left">
      <span class="text-2xl font-semibold text-green-600">৳{{ product.price }}</span>
      <span class="line-through text-gray-500">৳{{ product.price }}</span>
      <!--<span class="bg-red-100 text-red-600 px-2 py-1 rounded text-sm">
      -{{ product.discount }}%
    </span>-->
    </div>

    <!-- Size -->
    <!--product.sizeOptions-->
    <div class="text-left">
      <label class="font-medium">Size:</label>
      <div class="flex gap-2 mt-1 text-left">
        <button *ngFor="let s of sizes"
                (click)="selectedSize = s"
                [class.bg-blue-600]="selectedSize === s"
                [class.text-white]="selectedSize === s"
                class="px-4 py-2 border border-gray-300 rounded hover:bg-blue-100 transition">
          {{ s }}
        </button>
      </div>
    </div>

    <!-- Quantity Selector -->
    <div class="mb-4 flex items-center space-x-2 text-left">
      <button class="px-3 py-1 border border-gray-300 text-gray-700 rounded hover:bg-gray-100 text-left"
              (click)="decreaseQuantity()">
        −
      </button>
      <input type="number"
             [(ngModel)]="quantity"
             class="w-16 text-center border border-gray-300 rounded px-2 py-1"
             min="1" />
      <button class="px-3 py-1 border border-gray-300 text-gray-700 rounded hover:bg-gray-100"
              (click)="increaseQuantity()">
        +
      </button>
    </div>


    <!-- Description -->
    <div class="text-left">
      <h2 class="text-lg font-semibold text-gray-700 mb-1">Description</h2>
      <p class="text-gray-600 leading-relaxed">{{ product.description }}</p>
    </div>

    <!--Specifications-->
    <div [innerHTML]=specificationHtml class="text-left"></div>

    <!--<h6><strong>Specification:</strong></h6>
    <p class="text-gray-600 leading-relaxed">{{ product.specification }}</p>-->

    <!-- Add to Cart -->
    <button class="bg-blue-600 text-white px-6 py-3 rounded-xl hover:bg-blue-700 transition text-left"
            (click)="addToCart()">
      Add to Cart
    </button>

    <!-- Size Chart -->
    <div class="text-left">
      <h2 class="text-lg font-semibold text-gray-700 mb-2">Size Chart</h2>
      <table class="w-full text-left border border-gray-300 text-sm">
        <thead class="bg-gray-100">
          <tr>
            <th class="p-2 border">Size</th>
            <th class="p-2 border">Chest</th>
            <th class="p-2 border">Length</th>
            <th class="p-2 border">Sleeve</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let chart of sizeChart">
            <td class="p-2 border">{{ chart.size }}</td>
            <td class="p-2 border">{{ chart.chest }}</td>
            <td class="p-2 border">{{ chart.length }}</td>
            <td class="p-2 border">{{ chart.sleeve }}</td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</div>
